import { LocalAudioTrack } from 'twilio-video';
import { useTwilioUserMediaContext } from '../customer-call-sdk';

export type UseAudioTrackResult = LocalAudioTrack | undefined;

export default function useAudioTrack(): UseAudioTrackResult {
    const { audioTracks } = useTwilioUserMediaContext();
    return audioTracks.length > 0 ? audioTracks[0] : undefined;
}
